import { DOCUMENT } from '@angular/common';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { firstValueFrom } from 'rxjs';
import { SettingService } from './settings.service';

@Injectable({
  providedIn: 'root'
})
export class ApiService {

  constructor(private http: HttpClient, private settings: SettingService, @Inject(DOCUMENT) private document: Document) { }

  login(companyLoginName: string, username: string , password: string): Promise<any> {
    const headers = new HttpHeaders({
      'x_apim_key': this.settings.x_apim_key,
      'api_auth_key': this.settings.api_auth_key,
      'Content-Type': 'application/x-www-form-urlencoded'
    });
    const options = { headers: headers };
    const body = `grant_type=password&username=${companyLoginName}|${username}&password=${password}`;
    return firstValueFrom(this.http.post(this.settings.smeasyLoginUrl, body, options));
  }

  authorize(client_id: string, redirect_uri: string, state: string, smeasyJwt: string): void {
    const url = `${this.settings.authorizationUrl}?response_type=code&scope=read+offline_access&client_id=${client_id}&redirect_uri=${redirect_uri}&state=${state}&smeasy_jwt=${smeasyJwt}`;
    this.document.location.href = url;
  }
}
